export const Popover = {
  variants: {
    responsive: {
      content: { width: 'fit-content' },
    },
  },
};
